export var list = [
    'horizon',
    'riskLevel',
    'maxRecoveryPeriod',
    'foreignCurrencies',
    'investmentGoal',
];
